import React, { useMemo } from 'react';
import { Dimmer, Loader, Button, Grid } from 'semantic-ui-react';
import RenderSection from '../renderSections';
import { FormData } from '../../types';
import { useNotificationEmails } from '../../hooks/useNotificationEmails';

interface ProposalsStepProps {
  estateId?: string;
}

const ProposalsStep: React.FC<ProposalsStepProps> = ({ estateId }) => {
  const defaultFormData: FormData = useMemo(
    () => ({
      creationResponsible: false,
      client: false,
      estateMain: false,
      estateManager: false,
      tempMail: '',
      additionalRecipient: []
    }),
    []
  );

  const subcategories = useMemo(() => ['reminderEmission', 'policyConfirmation'], []);

  const titleMap: Record<string, string> = {
    reminderEmission: 'Lembrete de emissão (interno)',
    policyConfirmation: 'Emissão/Confirmação da apólice'
  };

  const { loading, formData, handleUpdateFormData, handleSave } = useNotificationEmails({
    estateId,
    category: 'proposals',
    subcategories,
    defaultFormData
  });

  return (
    <>
      <Dimmer active={loading} page>
        <Loader inline />
      </Dimmer>
      <div>
        {subcategories.map(subcategory => (
          <RenderSection
            key={subcategory}
            title={titleMap[subcategory]}
            sectionKey={subcategory}
            formData={formData[subcategory]}
            onUpdate={handleUpdateFormData}
          />
        ))}
      </div>
      <Grid style={{ marginLeft: '65%' }}>
        <Grid.Row columns={2} style={{ gap: '1rem' }}>
          <Button basic size="large">
            Cancelar
          </Button>
          <Button color="green" size="large" onClick={handleSave}>
            Salvar alterações
          </Button>
        </Grid.Row>
      </Grid>
    </>
  );
};

export default ProposalsStep;
